<app-dialog-container
  [title]="'Title.SubTitle.Contact'"
  [subtitle]="isSuccess() ? '' : 'Module.Reception.ContactPage.InfoText'"
  (closeDialogClicked)="closeDialog()"
>
  @if (!isSuccess()) {
    <form [formGroup]="contactForm" class="mt-4">
      <div class="space-y-6">
        <!-- Company and Name -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ "Table.Header.Company" | transloco }}</mat-label>
            <input matInput formControlName="Company" autocomplete="off" />
            @if (contactForm.get("Company")?.hasError("required")) {
              <mat-error>
                {{ "Validation.Required" | transloco }}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ "Table.Header.Name" | transloco }}</mat-label>
            <input matInput formControlName="FullName" autocomplete="off" />
            @if (contactForm.get("FullName")?.hasError("required")) {
              <mat-error>
                {{ "Validation.Required" | transloco }}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <!-- Email and Phone -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ "Table.Header.Email" | transloco }}</mat-label>
            <input matInput formControlName="Email" autocomplete="off" />
            @if (contactForm.get("Email")?.hasError("required")) {
              <mat-error>
                {{ "Validation.Required" | transloco }}
              </mat-error>
            }
            @if (contactForm.get("Email")?.hasError("email")) {
              <mat-error>
                {{ "Validation.Email" | transloco }}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ "Table.Header.PhoneNumber" | transloco }}</mat-label>
            <input matInput formControlName="PhoneNumber" autocomplete="off" />
            @if (contactForm.get("PhoneNumber")?.hasError("required")) {
              <mat-error>
                {{ "Validation.Required" | transloco }}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <!-- Availability and Sector -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ "Module.Reception.ContactPage.PreferredAvailability" | transloco }}</mat-label>
            <input matInput formControlName="PreferredAvailability" autocomplete="off" />
            @if (contactForm.get("PreferredAvailability")?.hasError("required")) {
              <mat-error>
                {{ "Validation.Required" | transloco }}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ "Module.Reception.ContactPage.Sector" | transloco }}</mat-label>
            <mat-select formControlName="Sector">
              @for (sector of ValidSector; track sector) {
                <mat-option [value]="sector">
                  {{ "Properties.Sector." + sector | transloco }}
                </mat-option>
              }
            </mat-select>
            @if (contactForm.get("Sector")?.hasError("required")) {
              <mat-error>
                {{ "Validation.Required" | transloco }}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <!-- Use Cases Section -->
        <div class="space-y-4">
          <h4 class="text-lg font-medium">{{ "Module.Reception.ContactPage.Cases" | transloco }}</h4>
          <div class="bg-gray-50 rounded-lg p-4">
            @if (contactForm.get("UseCases")?.hasError("required") && contactForm.get("UseCases")?.touched) {
              <mat-error class="mt-2">
                {{ "Validation.Required" | transloco }}
              </mat-error>
            }
            <mat-selection-list formControlName="UseCases" [disableRipple]="true" class="!py-0">
              @for (useCase of ValidUseCases; track useCase) {
                <mat-list-option [value]="useCase" class="!h-auto !py-2">
                  <div matTooltip="{{ 'Properties.UseCases.' + useCase | transloco }}" class="py-1">
                    {{ "Properties.UseCases." + useCase | transloco }}
                  </div>
                </mat-list-option>
              }
            </mat-selection-list>
          </div>
        </div>
      </div>
    </form>
  }
  @if (isSuccess()) {
    <div class="flex flex-col justify-center items-center h-full">
      <div>
        {{ "Module.Reception.Confirmation.Thanks" | transloco }}
      </div>
      <div>
        {{ "Module.Reception.Confirmation.BackSoon" | transloco }}
      </div>
      <mat-icon [svgIcon]="'icn-check'" class="text-green-500 !h-16 !w-16 mt-8" />
      <div class="text-base text-p1b mt-2">{{ "Button.MoreInformation" | transloco }}</div>
      <div>
        <app-text-button [text]="'Module.Reception.LandingPage.VideoExample'" (buttonPressed)="goToVideoExamples()" />
      </div>
    </div>
  }
  <div footer class="flex justify-end pt-6">
    <button mat-button mat-raised-button (click)="closeDialog()" class="px-6">
      {{ "Button.Close" | transloco }}
    </button>

    @if (!isSuccess()) {
      <button mat-button mat-raised-button color="accent" (click)="sendInformation()" class="ml-2 px-6">
        {{ "Button.Send" | transloco }}
      </button>
    }
  </div>
</app-dialog-container>
